
import { useState } from 'react';

export default function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState('all');

  const portfolioItems = [
    {
      id: 1,
      title: 'Yoga Apparel E-commerce Website',
      category: 'ecommerce',
      description: 'Launch your apparel sales with our free, easy-to-customize promotion template. Build a high-converting online store.',
      image: 'https://readdy.ai/api/search-image?query=Yoga%20apparel%20e-commerce%20website%20showing%20women%20in%20yoga%20wear%2C%20clean%20minimalist%20design%2C%20product%20showcase%2C%20modern%20online%20store%20layout%2C%20wellness%20branding%2C%20serene%20atmosphere%20with%20neutral%20colors%20and%20professional%20photography&width=400&height=300&seq=portfolio-yoga-001&orientation=landscape',
      tags: ['E-commerce', 'Health & Wellness', 'Fashion'],
      demoUrl: '#'
    },
    {
      id: 2,
      title: 'Travel Agency Site',
      category: 'travel',
      description: 'Ready to inspire wanderlust? This free Norway-themed travel agency website template makes it easy to create a captivating online presence.',
      image: 'https://readdy.ai/api/search-image?query=Travel%20agency%20website%20showcasing%20Norway%20mountains%20and%20fjords%2C%20adventure%20tourism%20layout%2C%20stunning%20landscape%20photography%2C%20modern%20travel%20booking%20interface%2C%20inspirational%20design%20with%20call-to-action%20buttons&width=400&height=300&seq=portfolio-travel-001&orientation=landscape',
      tags: ['Travel', 'Tourism', 'Adventure'],
      demoUrl: '#'
    },
    {
      id: 3,
      title: 'Architecture Studio Site',
      category: 'professional',
      description: 'A sophisticated and modern platform to showcase your architectural designs and connect with potential clients.',
      image: 'https://readdy.ai/api/search-image?query=Architecture%20studio%20website%20showing%20modern%20building%20designs%2C%20minimalist%20professional%20layout%2C%20architectural%20portfolio%20showcase%2C%20clean%20geometric%20design%2C%20sophisticated%20branding%20with%20high-quality%20project%20photography&width=400&height=300&seq=portfolio-architecture-001&orientation=landscape',
      tags: ['Architecture', 'Professional', 'Portfolio'],
      demoUrl: '#'
    },
    {
      id: 4,
      title: 'Japanese Spa Website',
      category: 'wellness',
      description: 'A tranquil and elegant online presence for your spa or massage therapy business with zen-inspired design.',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20spa%20website%20with%20zen%20aesthetics%2C%20traditional%20Japanese%20interior%20design%2C%20serene%20spa%20treatment%20rooms%2C%20minimalist%20wellness%20branding%2C%20natural%20wood%20textures%20and%20calming%20atmosphere&width=400&height=300&seq=portfolio-spa-001&orientation=landscape',
      tags: ['Spa', 'Wellness', 'Japanese Style'],
      demoUrl: '#'
    },
    {
      id: 5,
      title: 'Wedding Planner Site',
      category: 'events',
      description: 'Planning weddings is your passion, and our free Wedding Planner Website Template makes showcasing your expertise effortless.',
      image: 'https://readdy.ai/api/search-image?query=Wedding%20planner%20website%20showing%20elegant%20wedding%20ceremony%20setup%2C%20romantic%20venue%20photography%2C%20luxury%20wedding%20planning%20services%2C%20sophisticated%20branding%20with%20soft%20romantic%20colors%20and%20premium%20design%20elements&width=400&height=300&seq=portfolio-wedding-001&orientation=landscape',
      tags: ['Wedding', 'Events', 'Luxury'],
      demoUrl: '#'
    },
    {
      id: 6,
      title: 'Japanese Restaurant Website',
      category: 'restaurant',
      description: 'Free Japanese Restaurant Website Template offers a beautifully designed and easy-to-customize dining experience online.',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20restaurant%20website%20with%20traditional%20kaiseki%20cuisine%2C%20elegant%20food%20photography%2C%20authentic%20Japanese%20dining%20atmosphere%2C%20sophisticated%20restaurant%20branding%20with%20dark%20premium%20design%20and%20cultural%20elements&width=400&height=300&seq=portfolio-restaurant-001&orientation=landscape',
      tags: ['Restaurant', 'Japanese', 'Food & Beverage'],
      demoUrl: '#'
    },
    {
      id: 7,
      title: 'Modern Dental Clinic',
      category: 'medical',
      description: 'The Lumi Dental Clinic website template offers a sleek and modern design perfect for showcasing your dental practice online.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20dental%20clinic%20website%20showing%20clean%20medical%20facility%2C%20professional%20dental%20equipment%2C%20patient%20care%20areas%2C%20trustworthy%20healthcare%20branding%20with%20clean%20white%20design%20and%20medical%20professionalism&width=400&height=300&seq=portfolio-dental-001&orientation=landscape',
      tags: ['Healthcare', 'Medical', 'Dental'],
      demoUrl: '#'
    },
    {
      id: 8,
      title: 'Luxury Real Estate Website',
      category: 'realestate',
      description: 'Elevate your real estate brand with our free luxury real estate website template. Designed for agents and brokers.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20real%20estate%20website%20showcasing%20premium%20properties%2C%20modern%20architecture%20homes%2C%20high-end%20property%20listings%2C%20sophisticated%20real%20estate%20branding%20with%20elegant%20design%20and%20premium%20lifestyle%20imagery&width=400&height=300&seq=portfolio-realestate-001&orientation=landscape',
      tags: ['Real Estate', 'Luxury', 'Property'],
      demoUrl: '#'
    },
    {
      id: 9,
      title: 'SaaS Platform Landing Page',
      category: 'saas',
      description: 'Convert visitors into customers with our high-performing SaaS landing page template designed for maximum conversions.',
      image: 'https://readdy.ai/api/search-image?query=SaaS%20platform%20landing%20page%20showing%20software%20dashboard%20interface%2C%20modern%20tech%20startup%20design%2C%20professional%20business%20software%2C%20clean%20corporate%20branding%20with%20blue%20accents%20and%20technology%20imagery&width=400&height=300&seq=portfolio-saas-001&orientation=landscape',
      tags: ['SaaS', 'Technology', 'B2B'],
      demoUrl: '#'
    },
    {
      id: 10,
      title: 'Fitness & Gym Website',
      category: 'fitness',
      description: 'Powerful fitness website template to showcase your gym, personal training services, and fitness programs.',
      image: 'https://readdy.ai/api/search-image?query=Fitness%20gym%20website%20showing%20modern%20workout%20equipment%2C%20group%20fitness%20classes%2C%20personal%20training%20sessions%2C%20energetic%20fitness%20branding%20with%20bold%20colors%20and%20motivational%20athletic%20imagery&width=400&height=300&seq=portfolio-fitness-001&orientation=landscape',
      tags: ['Fitness', 'Gym', 'Health'],
      demoUrl: '#'
    },
    {
      id: 11,
      title: 'Creative Agency Portfolio',
      category: 'creative',
      description: 'Showcase your creative work with this modern agency portfolio template designed to impress potential clients.',
      image: 'https://readdy.ai/api/search-image?query=Creative%20agency%20portfolio%20website%20showing%20design%20work%2C%20branding%20projects%2C%20creative%20team%20workspace%2C%20modern%20agency%20office%2C%20artistic%20portfolio%20showcase%20with%20contemporary%20design%20and%20creative%20imagery&width=400&height=300&seq=portfolio-creative-001&orientation=landscape',
      tags: ['Creative', 'Design', 'Agency'],
      demoUrl: '#'
    },
    {
      id: 12,
      title: 'Online Course Platform',
      category: 'education',
      description: 'Launch your online education business with our comprehensive course platform template and learning management features.',
      image: 'https://readdy.ai/api/search-image?query=Online%20course%20platform%20showing%20video%20lessons%2C%20student%20dashboard%2C%20educational%20content%20interface%2C%20modern%20e-learning%20design%2C%20professional%20education%20branding%20with%20academic%20elements%20and%20learning%20imagery&width=400&height=300&seq=portfolio-education-001&orientation=landscape',
      tags: ['Education', 'E-learning', 'Courses'],
      demoUrl: '#'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Projects', count: portfolioItems.length },
    { id: 'ecommerce', name: 'E-commerce', count: portfolioItems.filter(item => item.category === 'ecommerce').length },
    { id: 'professional', name: 'Professional', count: portfolioItems.filter(item => ['professional', 'medical', 'realestate'].includes(item.category)).length },
    { id: 'wellness', name: 'Health & Wellness', count: portfolioItems.filter(item => ['wellness', 'fitness'].includes(item.category)).length },
    { id: 'business', name: 'Business', count: portfolioItems.filter(item => ['saas', 'creative'].includes(item.category)).length },
    { id: 'hospitality', name: 'Hospitality', count: portfolioItems.filter(item => ['restaurant', 'travel', 'events'].includes(item.category)).length }
  ];

  const filteredItems = activeCategory === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => {
        switch(activeCategory) {
          case 'professional':
            return ['professional', 'medical', 'realestate'].includes(item.category);
          case 'wellness':
            return ['wellness', 'fitness'].includes(item.category);
          case 'business':
            return ['saas', 'creative'].includes(item.category);
          case 'hospitality':
            return ['restaurant', 'travel', 'events'].includes(item.category);
          default:
            return item.category === activeCategory;
        }
      });

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Website Portfolio
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Explore our diverse collection of high-converting websites across different industries. Each project is designed to maximize conversions and deliver exceptional user experiences.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item) => (
            <div 
              key={item.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                
                {/* Overlay buttons */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <div className="flex space-x-4">
                    <a
                      href={item.demoUrl}
                      className="px-4 py-2 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap"
                    >
                      <i className="ri-eye-line mr-2"></i>View Demo
                    </a>
                    <button className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-300 whitespace-nowrap">
                      <i className="ri-information-line mr-2"></i>Details
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex flex-wrap gap-2 mb-3">
                  {item.tags.map((tag, index) => (
                    <span 
                      key={index}
                      className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed mb-4">
                  {item.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-blue-600 font-medium group-hover:text-blue-700 transition-colors duration-300">
                    <span>Learn More</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-2 transition-transform duration-300"></i>
                  </div>
                  
                  <div className="flex space-x-2">
                    <button className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-blue-100 transition-colors duration-300 cursor-pointer">
                      <i className="ri-heart-line text-gray-600 hover:text-blue-600"></i>
                    </button>
                    <button className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-blue-100 transition-colors duration-300 cursor-pointer">
                      <i className="ri-share-line text-gray-600 hover:text-blue-600"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call-to-Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Build Your Perfect Website?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Each website in our portfolio represents our commitment to creating high-converting, beautiful designs that drive results. Let's create something amazing for your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                Start Your Project
              </a>
              <a
                href="/pricing"
                className="inline-flex items-center px-8 py-4 bg-white text-blue-600 border-2 border-blue-600 rounded-lg font-medium hover:bg-blue-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-price-tag-3-line mr-2"></i>
                View Pricing
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
